import Form from '@/ui/Form'
import Title from '@/ui/Title';
import { useRouter } from 'next/router';
import React from 'react';
import classes from "./styles.module.scss";

const FormSection = ({title, formId, jobId, redirect_url, variant}) => {
  const router = useRouter()

  function onSubmitDone() {
    router.push(redirect_url);
  }
  
  function getClass() {
    switch(variant) {
      case 'plain':
        return classes.plain;
      case 'dark':
        return classes.dark;
      default:
        return classes.plain;
    } 
  }

  return (
    <div className={`${classes.form} ${getClass()}`}>
      {
        title &&
        <Title title={title} tag="h4" className={classes.title} />
      }
      <Form formId={formId} jobId={jobId} onSubmitDone={onSubmitDone} />
    </div>
  )
}

export default FormSection